module.exports = __webpack_public_path__ + "img/sq-13.90df6cab.jpg";